import * as onPointerMove from './onPointerMove.js';

export function pointerMove(event) {
  onPointerMove.onPointerMove(this, event);
}
